import { InjectionToken, Type } from '@angular/core';
import { NodeRenderer } from 'ngx-contentful-rich-text';

export const CONTENTFUL_NODE_RENDERERS = new InjectionToken<
  Record<string, Type<NodeRenderer>>
>('Contentful Node Renderers');
